enum ParamStorage {
    AppSettings = 'APP_SETTINGS',
    EmailTpl = 'EMAIL_TEMPLATES',
    SmsTpl = 'SMS_TEMPLATES',
    EmailCustomTags = 'EMAIL_CUSTOM_TAGS',
    EmailSignatures = 'EMAIL_SIGNATURES',
    EmailButtons = 'EMAIL_BUTTONS',
    EmailGdprPolicy = 'EMAIL_GDPR_POLICY', // TODO - Rename to plural
    Modules = 'MODULES',
    ModuleCards = 'MODULE_CARDS',
    Plannings = 'PLANNINGS',
    Schedulers = 'SCHEDULERS',
    Lists = 'LISTS',
    Views = 'VIEWS',
    ExcelExport = 'EXCEL_EXPORT', // TODO - Rename to plural
    PerfLogs = 'PERFORMANCE_LOGS',
    PublicTables = 'PUBLIC_TABLES',
    PublicForms = 'PUBLIC_FORMS',
    MigrationMappings = 'MIGRATION_MAPPINGS',
    VerifiedSenders = 'VERIFIED_SENDERS',
    DataExport = 'DATA_EXPORT',
    SortOrders = 'SORT_ORDERS',
    PdfTemplates = 'PDF_TEMPLATES',
    Testing = 'TESTING',
    DataConnections = 'DATA_CONNECTIONS',
}

export default ParamStorage;